import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { ConflitoInteresseService } from '@/core/api/sicom-api/registro/medico/conflito-interesse/conflito-interesse.service';
import { MedicoConflitoInteresseResponse, MedicoNaturezaVinculoResponse } from '@/core/api/sicom-api/registro/medico/conflito-interesse/conflito-interesse.model';

@Injectable({ providedIn: 'root' })
/** Fachada de conflito de interesse: ativos/inativos, naturezas de vínculo e upsert, com tratamento de erro. */
export class ConflitoInteresseFeatureService extends CustomService {
    private readonly core = inject(ConflitoInteresseService);

    buscar(params: Pessoa): Observable<MedicoConflitoInteresseResponse[]> {
        return this.core.buscar(params).pipe(catchError(this.handleError));
    }

    buscarInativo(params: Pessoa): Observable<MedicoConflitoInteresseResponse[]> {
        return this.core.buscarInativo(params).pipe(catchError(this.handleError));
    }

    listarNaturezasVinculo(): Observable<MedicoNaturezaVinculoResponse[]> {
        return this.core.listarNaturezasVinculo().pipe(catchError(this.handleError));
    }

    upsertConflitoInteresse(body: MedicoConflitoInteresseResponse): Observable<boolean> {
        return this.core.upsertConflitoInteresse(body).pipe(catchError(this.handleError));
    }
}
